'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadRecentWords = loadRecentWords;
exports.loadRecentWords3 = loadRecentWords3;
exports.loadDefinitions = loadDefinitions;
exports.analyzeSentence = analyzeSentence;
exports.createWordToContent = createWordToContent;
exports.loadRecentSentences = loadRecentSentences;
exports.loadTodayProgress = loadTodayProgress;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'LANGUAGE/LESSON/LOAD';
var SUCCESS = 'LANGUAGE/LESSON/SUCCESS';
var FAIL = 'LANGUAGE/LESSON/FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: false
      });

    case "RECENT_WORDS_LOAD":
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case "RECENT_WORDS_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        data: action.result
      });
    case "RECENT_WORDS_FAIL":
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case "DEFINITIONS_LOAD":
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case "DEFINITIONS_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        definitions: action.result
      });
    case "DEFINITIONS_FAIL":
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case "DEFINITIONS_2_LOAD":
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case "DEFINITIONS_2_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        definitions2: action.result
      });
    case "DEFINITIONS_2_FAIL":
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case "RECENT_SENTENCES_LOAD":
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case "RECENT_SENTENCES_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        sentences: action.result
      });
    case "RECENT_SENTENCES_FAIL":
      return (0, _extends3.default)({}, state, {
        loading: false
      });

    case "TODAY_PROGRESS_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        todayProgress: action.result
      });

    case "CREATE_WORD_TO_CONTENT_FAIL":
      console.log(action.error);
      return (0, _extends3.default)({}, state, {
        loading: false
      });

    default:
      return state;

  }
}

/*
 * Actions
 * * * * */
function isLoaded(globalState) {
  return globalState.language && globalState.language.loaded;
}

function loadRecentWords(pageNumber, targetLng) {
  var _targetLng = targetLng === undefined ? 'en' : targetLng;
  var step = 10;
  var mFilter = {
    offset: (pageNumber - 1) * step,
    limit: step,
    where: {
      targetLng: _targetLng
    },
    // ,fields: {
    //   id:true,
    //   name:true,
    //   parentContentId:true,
    //   previousContentId :true
    // }
    order: "last_seen desc"
  };
  // console.log('loadContents by lesson');
  return {
    types: ["RECENT_WORDS_LOAD", "RECENT_WORDS_SUCCESS", "RECENT_WORDS_FAIL"],
    promise: function promise(_ref) {
      var oneApiClient = _ref.oneApiClient;
      return oneApiClient.get('/UserWords/withDefinitionsV3', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadRecentWords3(pageNumber, targetLng) {
  var _targetLng = targetLng === undefined ? 'en' : targetLng;
  var step = 10;
  var mFilter = {
    offset: (pageNumber - 1) * step,
    limit: step,
    where: {
      targetLng: _targetLng
    },
    // ,fields: {
    //   id:true,
    //   name:true,
    //   parentContentId:true,
    //   previousContentId :true
    // }
    order: "last_seen desc"
  };
  // console.log('loadContents by lesson');
  return {
    types: ["RECENT_WORDS_LOAD", "RECENT_WORDS_SUCCESS", "RECENT_WORDS_FAIL"],
    promise: function promise(_ref2) {
      var oneApiClient = _ref2.oneApiClient;
      return oneApiClient.get('/UserWords/withDefinitionsV3', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadDefinitions(text, lang, targetLng) {
  // var step = 20;
  var _targetLng = targetLng === undefined ? 'en' : targetLng;
  var mFilter = {
    // offset: (pageNumber - 1) * step,
    // limit: step,
    where: {
      lang: lang,
      text: text,
      targetLng: _targetLng
      // ,fields: {
      //   id:true,
      //   name:true,
      //   parentContentId:true,
      //   previousContentId :true
      // }
      // order: "last_seen desc"
    } };
  // console.log('loadContents by lesson');
  return {
    types: ["DEFINITIONS_LOAD", "DEFINITIONS_SUCCESS", "DEFINITIONS_FAIL"],
    promise: function promise(_ref3) {
      var oneApiClient = _ref3.oneApiClient;
      return oneApiClient.get('/UserWords/withDefinitionsForOne', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function analyzeSentence(text, lang) {
  // var step = 20;
  var mFilter = {
    sentence: text,
    lang: lang
  };
  return {
    types: ["DEFINITIONS_2_LOAD", "DEFINITIONS_2_SUCCESS", "DEFINITIONS_2_FAIL"],
    promise: function promise(_ref4) {
      var oneApiClient = _ref4.oneApiClient;
      return oneApiClient.post('/UserWords/analyzeSentence', {
        data: mFilter
      });
    } //
  };
}

function createWordToContent(word, contentId, type, lang) {
  var data = {
    word: word,
    contentId: contentId,
    // langWrittenIn: lang, // default => en or get from content table... that's it!
    typeId: type,
    lang: lang
  };
  // console.log('loadContents by lesson');
  return {
    types: ["CREATE_WORD_TO_CONTENT_LOAD", "CREATE_WORD_TO_CONTENT_SUCCESS", "CREATE_WORD_TO_CONTENT_FAIL"],
    promise: function promise(_ref5) {
      var oneApiClient = _ref5.oneApiClient;
      return oneApiClient.post('/WordToContents', {
        data: data
      });
    } //
  };
}

function loadRecentSentences(pageNumber) {
  var step = 20;
  var mFilter = {
    offset: (pageNumber - 1) * step,
    limit: step,
    where: {
      // lang: 'es'
    },
    // ,fields: {
    //   id:true,
    //   name:true,
    //   parentContentId:true,
    //   previousContentId :true
    // }
    order: "modified desc"
  };
  // console.log('loadContents by lesson');
  return {
    types: ["RECENT_SENTENCES_LOAD", "RECENT_SENTENCES_SUCCESS", "RECENT_SENTENCES_FAIL"],
    promise: function promise(_ref6) {
      var oneApiClient = _ref6.oneApiClient;
      return oneApiClient.get('/Sentences', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadTodayProgress(userId) {
  var today = new Date().toISOString().slice(0, 10);
  var mFilter = {
    userId: userId,
    date: today
    // date: '2018-12-03'
  };
  // console.log('loadContents by lesson');
  return {
    types: ["TODAY_PROGRESS_LOAD", "TODAY_PROGRESS_SUCCESS", "TODAY_PROGRESS_FAIL"],
    promise: function promise(_ref7) {
      var oneApiClient = _ref7.oneApiClient;
      return oneApiClient.get('/UserWords/statistics', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/language.js
// module id = 73
// module chunks = 0